/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AlertNotificationSetting } from '../../models/alert-notification-setting';

export interface FindByRoleId$Params {
  roleId: number;
}

export function findByRoleId(http: HttpClient, rootUrl: string, params: FindByRoleId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AlertNotificationSetting>>> {
  const rb = new RequestBuilder(rootUrl, findByRoleId.PATH, 'get');
  if (params) {
    rb.path('roleId', params.roleId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AlertNotificationSetting>>;
    })
  );
}

findByRoleId.PATH = '/api/notification/alert/setting/roleId/{roleId}';
